var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Description from '../description';
import Divider from '../divider';
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Typography } from '..';
const StyledListItemHeader = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 20px;
  [data-role='list-item-header-right'] {
    margin-left: auto;
    margin-right: 0px;
    font-weight: normal;
  }
  [data-role='description'] {
    margin-top: 0px;
    width: 100%;
  }
  [data-role='description-tile'] {
    margin-top: 0px;
    width: 100%;
  }
`;
const Left = styled.span `
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateX(-100%) translateX(-4px) translateY(-50%);
  display: flex;
  align-items: center;
`;
const Title = styled.div `
  display: flex;
  align-items: center;
`;
export const ListItemHeader = (props) => {
    return (React.createElement(StyledListItemHeader, { className: "list-item-header", "data-role": "list-item-header" },
        React.createElement(Description, { title: React.createElement(Title, null,
                React.createElement(Left, null, props.left),
                props.title,
                React.createElement("div", { "data-role": "list-item-header-right", className: "list-item-header-right" }, props.right)), content: props.subTitle })));
};
const StyledListItemParagraph = styled(Typography.Paragraph) `
  padding-left: 20px;
  margin-top: 0px;
`;
export const ListItemParagraph = (props) => {
    return (React.createElement(StyledListItemParagraph, { className: "list-item-paragraph", "data-role": "list-item-paragraph", line: props.line }, props.children));
};
const StyledListItem = styled.div `
  padding: 12px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  [data-role='divider'] {
    margin-bottom: 0px;
  }
`;
export const ListItem = (_a) => {
    var { borderless = false } = _a, props = __rest(_a, ["borderless"]);
    return (React.createElement(StyledListItem, { className: "list-item", "data-role": "list-item" },
        props.children,
        !borderless && React.createElement(Divider, { style: { margin: 0 }, type: "horizontal" })));
};
const StyledList = styled.div `
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: ${(props) => props.transparent ? 'transparent' : 'var(--bg-color)'};
`;
export function List(props) {
    var _a;
    return (React.createElement(StyledList, { className: cx('list', props.className), "data-role": "list" }, (_a = props.dataSource) === null || _a === void 0 ? void 0 : _a.map((item, index) => { var _a; return (_a = props.renderItem) === null || _a === void 0 ? void 0 : _a.call(props, item, index); })));
}
